<div mat-dialog-content class="dialog-content">
  <div class="title-box">{{ title }}</div>
  <div class="description">{{ description }}</div>

  <mat-form-field class="reason-field">
    <textarea
      matInput
      rows="2"
      [maxlength]="maxLength"
      [(ngModel)]="reason"
    ></textarea>
  </mat-form-field>

  <div class="reason-counter">
    {{ reason.length }}/{{ maxLength }}
  </div>

  <div class="actions">
    <button
      class="btn btn-primary btn-rounded btn-block"
      [disabled]="!canConfirm"
      (click)="onConfirm()"
    >
      {{ confirmText }}
    </button>

    <button class="btn btn-transparent btn-rounded btn-block" (click)="onCancel()">
      CANCELAR
    </button>
  </div>
</div>
